import { match } from 'path-to-regexp';
import getPath from './getPath';

export default function isPath(pathnameToCheck, pathnameToMatch) {
  const pathListToMatch = [].concat(pathnameToMatch);
  const [basePathnameToCheck] = pathnameToCheck.split(/[?#]/);

  const matchingResults = Array.from(pathListToMatch, (path) => {
    const pathWithLang = getPath(path);
    const matcher = match(pathWithLang, { decode: decodeURIComponent });

    const result = matcher(basePathnameToCheck);
    return !!result;
  });

  return matchingResults.some((result) => result === true);
}
